import React, { useContext } from 'react'
import toast from 'react-hot-toast'
import { InitializeContext } from '../../App';

export default function X() {
          const { theme } = useContext(InitializeContext);

          const getOSName = () => {
                    let os = '';
                    const userAgent = window.navigator.userAgent,
                              platform = window.navigator.platform,
                              macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
                              windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
                              iosPlatforms = ['iPhone', 'iPad', 'iPod']

                    if (macosPlatforms.indexOf(platform) !== -1) {
                              os = 'Mac OS';
                    } else if (iosPlatforms.indexOf(platform) !== -1) {
                              os = 'iOS';
                    } else if (windowsPlatforms.indexOf(platform) !== -1) {
                              os = 'Windows';
                    } else if (/Android/.test(userAgent)) {
                              os = 'Android';
                    } else if (!os && /Linux/.test(platform)) {
                              os = 'Linux';
                    }

                    return os;
          }

          const getBrowserName = () => {
                    const userAgent = navigator.userAgent;
                    let browserName = '';
                    if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
                              browserName = 'Opera';
                    } else if (userAgent.indexOf('Edg') > -1) {
                              browserName = 'Microsoft Edge';
                    } else if (userAgent.indexOf('Chrome') > -1) {
                              browserName = 'Google Chrome';
                    } else if (userAgent.indexOf('Safari') > -1) {
                              browserName = 'Apple Safari';
                    } else if (userAgent.indexOf('Firefox') > -1) {
                              browserName = 'Mozilla Firefox';
                    } else if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident/') > -1) {
                              browserName = 'Internet Explorer';
                    }
                    return browserName;
          }

          const handleXClick = () => {
                    toast.success(`You're using ${getBrowserName()} browser & ${getOSName()} operating system.`, {
                              icon: '👏',
                              style: {
                                        borderRadius: '10px',
                                        background: `${theme ? '#333' : '#fff'}`,
                                        color: `${theme ? '#fff' : '#000'}`,
                              },
                              duration: 4000,
                    });
          }

          return (
                    <div className={`flex justify-center items-center h-screen ${theme ? 'bg-black' : 'bg-[#ECF0F3]'} select-none`}>
                              <h1 className={`text-3xl ${theme ? 'text-white' : 'text-black'} cursor-pointer select-none font-semibold glass px-4 py-1 rounded-lg`} onClick={handleXClick}>X</h1>
                    </div>
          )
}
